export enum PrescriptionRequestChannel {
  CREATE = 'prescriptionRequest::create',
  EDIT = 'prescriptionRequest::patch',
  DELETE = 'prescriptionRequest::delete',
}
